import React, { useEffect, useState } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../env";

const RoomTag = () => {
  const [hotels, setHotels] = useState([]);
  const [hotelId, setHotelId] = useState("");
  const [roomConfigs, setRoomConfigs] = useState([]);
  const [formValues, setFormValues] = useState({});
  const [loading, setLoading] = useState(false);

  // Fetch hotels list
  const fetchHotels = async () => {
    try {
      const res = await axios.get(
        `${REACT_APP_API_URL}api/room-tariff/get-hotels`
      );
      setHotels(res.data.data || []);
    } catch (err) {
      console.error("Error fetching hotels:", err);
    }
  };

  useEffect(() => {
    fetchHotels();
  }, []);

  // Fetch room configs when hotel changes
  useEffect(() => {
    const fetchRoomConfigs = async () => {
      try {
        const allRes = await axios.post(
          `${REACT_APP_API_URL}api/dashboard/admin/get-room-config`,
          {
            P_CHRACTION: "ALL",
            P_INTPROPERTYID: hotelId,
          }
        );
        const allRoomTypes = allRes.data.data || [];

        const availableRes = await axios.post(
          `${REACT_APP_API_URL}api/dashboard/admin/get-room-config`,
          {
            P_CHRACTION: "T",
            P_INTPROPERTYID: hotelId,
          }
        );
        const availableRooms = availableRes.data.data || [];

        const initial = {};
        allRoomTypes.forEach((room) => {
          const matchedRoom = availableRooms.find(
            (r) => r.HotelRoomConfigID === room.HotelRoomConfigID
          );
          const isTagged = matchedRoom ? matchedRoom.Status === 1 : false;

          initial[room.HotelRoomConfigID] = {
            ...room,
            Ticket: isTagged,
            NoOfPersonAllowed: isTagged ? matchedRoom?.NoOfPersonAllowed || "" : "",
            ExtraPeson: isTagged && matchedRoom?.ExtraPeson > 0 ? "Yes" : "No",
            ExtraPesonValue:
              isTagged && matchedRoom?.ExtraPeson > 0 ? matchedRoom.ExtraPeson : "",
            NoOfExtraPerson: isTagged ? matchedRoom?.NoOfExtraPerson || "" : "",
            ExtraBedAvailable:
              isTagged && matchedRoom?.ExtraBedAvailable > 0 ? "Yes" : "No",
            ExtraBedAvailableValue:
              isTagged && matchedRoom?.ExtraBedAvailable > 0
                ? matchedRoom.ExtraBedAvailable
                : "",
            HotelRoomConfigDetailID: isTagged
              ? matchedRoom?.HotelRoomConfigDetailID
              : 0,
          };
        });

        setRoomConfigs(allRoomTypes);
        setFormValues(initial);
      } catch (err) {
        console.error("Error loading room configs:", err);
      }
    };

    if (hotelId) {
      setRoomConfigs([]);
      setFormValues({});
      fetchRoomConfigs();
    }
  }, [hotelId]);

  // Handle field change
  const handleInputChange = (roomId, field, value) => {
    setFormValues((prev) => ({
      ...prev,
      [roomId]: {
        ...prev[roomId],
        [field]: value,
      },
    }));
  };

  // Submit XML data
  const handleSubmit = async () => {
    if (!hotelId) {
      alert("Please select a hotel.");
      return;
    }

    // Filter only tagged rooms
    const taggedRooms = Object.values(formValues).filter((r) => r.Ticket);

    if (taggedRooms.length === 0) {
      alert("Please select at least one room to tag.");
      return;
    }

    // Create XML string
    const xml = `<ArrayOfHotelRoomConfig>
    ${taggedRooms
      .map(
        (room) => `
      <HotelRoomConfig>
        <HotelRoomConfigDetailID>${room.HotelRoomConfigDetailID || 0}</HotelRoomConfigDetailID>
        <HotelRoomConfigID>${room.HotelRoomConfigID || 0}</HotelRoomConfigID>
        <NoOfPersonAllowed>${room.NoOfPersonAllowed || 0}</NoOfPersonAllowed>
        <ExtraPeson>${
          room.ExtraPeson === "Yes" ? room.ExtraPesonValue || 0 : 0
        }</ExtraPeson>
        <NoOfExtraPerson>${
          room.ExtraPeson === "Yes" ? room.NoOfExtraPerson || 1 : 0
        }</NoOfExtraPerson>
        <ExtraBedAvailable>${
          room.ExtraBedAvailable === "Yes" ? room.ExtraBedAvailableValue || 0 : 0
        }</ExtraBedAvailable>
      </HotelRoomConfig>`
      )
      .join("")}
    </ArrayOfHotelRoomConfig>`;

    try {
      setLoading(true);
      const res = await axios.post(
        `${REACT_APP_API_URL}api/dashboard/admin/tag-room-config`,
        {
          propertyId: hotelId,
          createdBy: 1,
          xmlData: xml,
        }
      );
      alert(res.data.message || "Room config tagged successfully.");
    } catch (err) {
      console.error("Submit error:", err);
      alert("Submission failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <h4 className="mb-3">Tag Room Configuration with Hotel</h4>

      {/* Hotel selection */}
      <div className="mb-4">
        <label className="form-label">Select Hotel</label>
        <select
          className="form-control"
          style={{ maxWidth: "30%" }}
          value={hotelId}
          onChange={(e) => setHotelId(e.target.value)}
        >
          <option value="">Select Hotel</option>
          {hotels.map((hotel) => (
            <option key={hotel.PropertyID} value={hotel.PropertyID}>
              {hotel.UnitName}
            </option>
          ))}
        </select>
      </div>

      {/* Room configs table */}
      {roomConfigs.length > 0 && (
        <div className="table-responsive">
          <table className="table table-bordered align-middle">
            <thead className="table-light">
              <tr>
                <th>Ticket</th>
                <th>Sl</th>
                <th>Room Type</th>
                <th>No. of Person</th>
                <th>Extra Person</th>
                <th>Extra Bed</th>
              </tr>
            </thead>
            <tbody>
              {roomConfigs.map((room, index) => {
                const data = formValues[room.HotelRoomConfigID] || {};
                return (
                  <tr key={room.HotelRoomConfigID}>
                    <td>
                      <input
                        type="checkbox"
                        checked={data.Ticket || false}
                        onChange={(e) =>
                          handleInputChange(
                            room.HotelRoomConfigID,
                            "Ticket",
                            e.target.checked
                          )
                        }
                      />
                    </td>
                    <td>{index + 1}</td>
                    <td className="fw-bold">{room.RoomType}</td>
                    <td>
                      <input
                        type="number"
                        className="form-control"
                        value={data.NoOfPersonAllowed || ""}
                        onChange={(e) =>
                          handleInputChange(
                            room.HotelRoomConfigID,
                            "NoOfPersonAllowed",
                            e.target.value
                          )
                        }
                      />
                    </td>
                    <td>
                      <div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name={`extraPerson-${room.HotelRoomConfigID}`}
                            checked={data.ExtraPeson === "Yes"}
                            onChange={() =>
                              handleInputChange(
                                room.HotelRoomConfigID,
                                "ExtraPeson",
                                "Yes"
                              )
                            }
                          />
                          <label className="form-check-label">Yes</label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name={`extraPerson-${room.HotelRoomConfigID}`}
                            checked={data.ExtraPeson === "No"}
                            onChange={() =>
                              handleInputChange(
                                room.HotelRoomConfigID,
                                "ExtraPeson",
                                "No"
                              )
                            }
                          />
                          <label className="form-check-label">No</label>
                        </div>
                        {data.ExtraPeson === "Yes" && (
                          <input
                            type="number"
                            className="form-control mt-1"
                            placeholder="Enter value"
                            value={data.ExtraPesonValue || ""}
                            onChange={(e) =>
                              handleInputChange(
                                room.HotelRoomConfigID,
                                "ExtraPesonValue",
                                e.target.value
                              )
                            }
                          />
                        )}
                      </div>
                    </td>
                    <td>
                      <div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name={`extraBed-${room.HotelRoomConfigID}`}
                            checked={data.ExtraBedAvailable === "Yes"}
                            onChange={() =>
                              handleInputChange(
                                room.HotelRoomConfigID,
                                "ExtraBedAvailable",
                                "Yes"
                              )
                            }
                          />
                          <label className="form-check-label">Yes</label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name={`extraBed-${room.HotelRoomConfigID}`}
                            checked={data.ExtraBedAvailable === "No"}
                            onChange={() =>
                              handleInputChange(
                                room.HotelRoomConfigID,
                                "ExtraBedAvailable",
                                "No"
                              )
                            }
                          />
                          <label className="form-check-label">No</label>
                        </div>
                        {data.ExtraBedAvailable === "Yes" && (
                          <input
                            type="number"
                            className="form-control mt-1"
                            placeholder="Enter value"
                            value={data.ExtraBedAvailableValue || ""}
                            onChange={(e) =>
                              handleInputChange(
                                room.HotelRoomConfigID,
                                "ExtraBedAvailableValue",
                                e.target.value
                              )
                            }
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* Submit Button */}
      {hotelId && (
        <button
          className="btn btn-primary mt-3"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Saving..." : "Submit"}
        </button>
      )}
    </div>
  );
};

export default RoomTag;